import Plyr from 'plyr';

document.querySelectorAll('video[controls]').forEach(video => {
    const poster = video.getAttribute('poster')

    if (poster) {
        video.setAttribute('data-poster', poster);
      }
      
      new Plyr(video, {
        controls: [
          'play-large', // The large play button in the center
          'play', // Play/pause playback
          'progress', // The progress bar and scrubber for playback and buffering
          'current-time', // The current time of playback
          'mute', // Toggle mute
          'volume', // Volume control
          'fullscreen' // Toggle fullscreen
        ]
      });
})
